import { Size, Variant } from './types';

export const INVALID_VARIANTS_FOR_REGULAR_MEDIUM_SIZE = ['white', 'always_white'];

export const isInvalidVariantForSize = (size: Size, variant: Variant) => {
  return (
    ['regular', 'medium'].includes(size) &&
    INVALID_VARIANTS_FOR_REGULAR_MEDIUM_SIZE.includes(variant)
  );
};

export const VariantIconColorStates = {
  primary: {
    default: 'icon-primary-control',
    disabled: 'icon-disabled',
    loading: 'icon-primary-control',
  },
  deposit: {
    default: 'icon-deposit-button',
    disabled: 'icon-disabled',
    loading: 'icon-deposit-button',
  },
  secondary: {
    default: 'icon-main',
    disabled: 'icon-disabled',
    loading: 'icon-main',
  },
  tertiary: {
    default: 'icon-main',
    disabled: 'icon-disabled',
    loading: 'icon-main',
  },
  white: {
    default: 'icon-always-dark',
    disabled: 'icon-disabled-always-light',
    loading: 'icon-primary-control',
  },
  always_white: {
    default: 'icon-always-dark',
    disabled: 'icon-disabled-always-light',
    loading: 'icon-primary-control',
  },
  text_button: {
    default: 'icon-main',
    disabled: 'icon-disabled',
    loading: 'icon-main',
  },
};

export const IconSizes = {
  default: 20,
  low: 16,
};

export const SQUARE_SHAPE = 'square';
